const getCategoryFromId = (categoryId, categories) => {
  const category = categories.find((category) => category.id === categoryId);
  return category;
};

const getBrandFromId = (brandId, brands) => {
  const brand = brands.find((brand) => brand.id === brandId);
  return brand;
};

const objectsEqual = (o1, o2) =>
  typeof o1 === "object" && Object.keys(o1).length > 0
    ? Object.keys(o1).length === Object.keys(o2).length &&
      Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
    : o1 === o2;

const arraysEqual = (a1, a2) =>
  a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

export { getCategoryFromId, getBrandFromId, objectsEqual, arraysEqual };
